<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headers"
      :items="itemsCodigoServico"
      :items-per-page="8"
      :loading="loading"
      :search="search"
      :paginate="true"
      :footer-props="{ itemsPerPageText: 'Linhas por página' }"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="d-flex align-center pa-0">

          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn 
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              @click="openModal()"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <v-text-field
              class="ma-0 pa-0"
              v-model="search"
              :placeholder="'Buscar por código do serviço'"
              prepend-inner-icon="mdi-magnify"
              outlined
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.ativo`]="{ item }">
        <div class="d-flex w-100">
          <v-switch
            v-can:permission="'bloqueio-entrada-nf#update'"
            color="primary"
            v-model="item.ativo"
            @click.native.stop="changeStatus(item)"
          ></v-switch>
          <v-icon :color="item.ativo ? 'primary' : 'default'" class="ml-2 mt-1">
            {{
              item.ativo ? "mdi mdi-checkbox-marked-circle-outline" : "mdi mdi-close-circle-outline"
            }}
          </v-icon>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          v-can:permission="'cnpj-despesa#delete'"
          icon
          @click="deleteCodigo(item)"
        >
          <v-icon color="error">mdi-trash-can</v-icon>
        </v-btn>
      </template>
    </BaseDataTable>

    <ModalCadastro
      :dialog="dialog"
      :labelBtn="'Cadastrar'"
      :itemModal="itemModal"
      @close="closeModal($event)"
    />
  </v-card>
</template>

<script>
import BaseDataTable from "@/components/BaseDataTable";
import codigoServicoG4 from "@/services/http/rpa/CodigosServicoG4.js";
import ModalCadastro from "./ModalCadastro.vue";
import toast from "@/commom/toast";
export default {
  components: {
    BaseDataTable,
    ModalCadastro
  },
  data() {
    return {
      dialog: false,
      search: "",
      id: "",
      loading: false,
      itemsCodigoServico: [],
      itemModal: {},
      filterMenu: false,
      headers: [
        {
          text: "Código do Serviço",
          value: "id",
          align: "center",
          sortable: true,
          filterable: true,
        },
        {
          text: "Status",
          value: "ativo",
        },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    async fetchCodigos() {
      try {
        this.loading = true;
        let { data } = await codigoServicoG4().show({ per_page: 8 });
        this.itemsCodigoServico = data.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    openModal() {
      this.dialog = true;
    },

    closeModal(event) {
      if (event == "refresh") {
        this.fetchCodigos(this.filter);
      }
      this.dialog = false;
    },

    async changeStatus(item) {
      let negation = !item.ativo;
      item.ativo = negation;

      try {
        this.loading = true;
        let text = item.ativo === 0 ? "ativar" : "inativar";
        await this.$swal({
          title: `${text} código de serviço`,
          text: `Deseja ${text} este código?`,
          icon: "question",
          showDenyButton: true,
          confirmButtonText: `Sim! ${text}`,
          denyButtonText: "Não, cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await codigoServicoG4(item.id).update({
              ativo: item.ativo ? 0 : 1,
            });
            item.ativo = !negation;
            return;
          }
        });
        toast("success", `Status alterado com sucesso`);
      } catch (e) {
        toast("error", "Erro: " + e.message);
        console.log(e);
      }finally{
        this.loading = false;
      }
    },

    async deleteCodigo(item) {
      let res = await this.$swal({
        title: `Deseja apagar o Código de Serviço  ${item.id} da lista ?`,
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar Código de Serviço",
        cancelButtonText: "Não, cancelar",
      });
      if (!res.isConfirmed) return;
      try {
        await codigoServicoG4(item.id).delete();
        toast("success", "Código removido da lista");
      } catch (err) {
        toast("error", "Erro inesperado: "+ err.message);
      } finally {
        this.fetchCodigos(this.filter);
      }
    },

  },

  

  created() {
    this.fetchCodigos();
  },
};
</script>

<style scoped>
/deep/.v-input__slot {
  background-color: #eef2f7 !important;
  margin: 0 !important;
}
</style>
